/*
 * File: input-type-prop.ts
 * File Created: 2024-01-17 03:17:19
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2026-01-16 12:23:43
 * Modified By: Val Liu <valuis0429@gmail.com>
 * -----
 */

import { PropOptions } from "vue";

/// variants
export const StringInputTypes = [
    "hidden",
    "text",
    "number",
    "email",
    "password",
    "search",
    "url",
    "tel",
    "date",
    "time",
    "range",
    "color",
] as const;
export type StringInputType = (typeof StringInputTypes)[number];

export function typeProp(): PropOptions<string> {
    return {
        type: String,
        default: "text",
        validator: (value: string) => {
            const isValid = StringInputTypes.includes(value as StringInputType);
            if (!isValid) {
                console.error(`<${value}> is not a valid value for <type>.`);
            }
            return isValid;
        },
    };
}
